"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const SearchItemQuery = (0, graphql_tag_1.default)(`
  query searchQuery(
    $term: String = ""
    $filters: [FilterInput]
    $sortType: String
    $sortOrientation: String
    $page: Int
    $pageSize: Int = 10
    $zipCode: String
    $partnerId: String
    $sellerId: String
    $customerId: String
  ) {
    search(
      searchRequest: {
        query: $term
        pagination: { page: $page, size: $pageSize }
        filters: $filters
        sort: { type: $sortType, orientation: $sortOrientation }
        location: { zipCode: $zipCode}
        metadata: {
          partnerId: $partnerId
          sellerId: $sellerId
          customerId: $customerId
        }
      }
    ) {
      items {
        type
        id
        offerId
        image
        title
        description
        reference
        available
        isBuyBox
        path
        tags
        isFavorited
        minimumOrderQuantity
        ads {
          sponsored
        }
        offers {
          bestPrice {
              totalAmount
          }
          discounts {
              discountPrice
              description
          }
          bestInstallmentPlan {
            paymentMethodDescription
            totalAmount
            installmentAmount
            installment
          }
          badges {
            text
            imageUrl
          }
          seller {
            legalName
            id
            stats {
              totalSales
            }
            isChatEnabled
          }
        }
        rating {
          count
          score
        }
      }
    }
  }
`);
exports.default = SearchItemQuery;
